import { useMountEffect } from '@react-hookz/web';
import qs from 'query-string';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import LinkButton from 'src/app/components/Elements/Button/LinkButton';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { mfaForm } from 'src/app/router/paths';
import { HAS_SEEN_MFA_INTERSTIAL_IN_PAST } from 'src/app/storage/localStorageKeys';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: ${({ theme }) => theme.space.s8} auto;
  max-width: calc(100vw - (48px * 2));
  text-align: center;

  ${({ theme }) => theme.mediaQueries.smallDown} {
    margin: ${({ theme }) => theme.space.s6} auto;
  }

  &&& > h1 {
    padding: 0;
    margin-bottom: ${({ theme }) => theme.space.s3};
    font-size: 2.8rem !important;
  }

  & > p {
    padding: 0;
    max-width: 50ch;
    margin-bottom: ${({ theme }) => theme.space.s8};
  }

  & > img {
    width: 100%;
    max-width: 300px;
    margin-bottom: ${({ theme }) => theme.space.s8};
  }
`;

const LinkWithButtonAppearance = styled(LinkButton).attrs({
  style: 'capsuleBlue50',
  size: 'medium',
})`
  &&& {
    margin: 0;
    text-decoration: none;
  }
`;

export const MFAInterstitial = () => {
  useSegmentEvent('viewLoginVerification', { shouldTrackOnMount: true });

  const location = useLocation();
  const { flow } = qs.parse(location.search);
  const flowQs = flow ? `?flow=${flow}` : '';

  useMountEffect(() => {
    window.localStorage.setItem(HAS_SEEN_MFA_INTERSTIAL_IN_PAST, 'true');
  });

  return (
    <Container>
      {/* TODO: Use new TypographyComponent with responsive variants */}
      <h1 className="h4 font-h-4">Confirm it’s you</h1>

      <p>We’ve made your account even more secure with 2-factor authentication. Click next to confirm your account.</p>

      <img alt="" src="/public/mfa-demo.webp" />

      <LinkWithButtonAppearance data-testid="next" to={`${mfaForm.toPath()}${flowQs}`}>
        NEXT
      </LinkWithButtonAppearance>
    </Container>
  );
};
